import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { BufferRecipeCalc } from "../components/BufferRecipeCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.buf_tool_name()}
        toolPath="/buffer-recipe-calculator"
      />
      <SciHeader title={m.buf_h1()} intro={m.buf_intro()} />
      <BufferRecipeCalc />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.buf_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.buf_ex1(), m.buf_ex2(), m.buf_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.buf_faq_q1(), a: m.buf_faq_a1() },
          { q: m.buf_faq_q2(), a: m.buf_faq_a2() },
          { q: m.buf_faq_q3(), a: m.buf_faq_a3() },
          { q: m.buf_faq_q4(), a: m.buf_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
